import styled from "styled-components";
import { FONTS, HELPERS } from "../../../shared";
import { MEDIA_QUERY } from "../../../entities/Common";

export const CustomizeSliderStyled = styled.div`
  .customize-slider {
    &__input {
      width: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: ${HELPERS.TRANSITION};
      &:hover {
        transform: scale(0.95);
      }
    }
    &__range {
      width: calc(100% - 130px);
    }
  }
  .customize-range {
    &__labels {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:first-child {
        margin-bottom: 20px;
      }
      &:last-child {
        margin-top: 20px;
      }
      span {
        font-size: ${FONTS.FONT_SIZE_SMALL};
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    .customize {
      &-slider {
        &__input {
          width: 25px;
        }
        &__range {
          width: calc(100% - 100px);
        }
      }
    }
  }
`;
